module.exports = __webpack_public_path__ + "img/img5_8.cb496fa0.jpeg";